export class RoutePath {

    //Admin Portal Start
    //Login
    static readonly Admin_Login_page: string = '/admin-login';
    static readonly Admin_Dashborad_page: string = '/admin-dashboard';
    static readonly Admin_Login_OTP: string = '/admin-otp';
    static readonly Admin_Login_Logout: string = '/admin-logout';

    static readonly Admin_ForgetPassword: string = '/admin-forget-password';
    static readonly Admin_ResetPassword: string = '/admin-reset-password';

    static readonly Admin_Profile: string = '/admin-profile';

    static readonly Admin_TenantList: string = '/garages';
    static readonly Admin_TenantOnboard: string = '/garage-onboard';
    static readonly Admin_TenantEdit: string = '/garage-edit';

    //Master Data Setup
    static readonly Admin_ServiceTypes: string = '/service-types';
    static readonly Admin_Services: string = '/services';
    static readonly Admin_VehicleModels: string = '/vehicle-models';

    //Subscription
    static readonly Admin_Subscriptions: string = '/subscriptions';
    static readonly Admin_Subscription_new: string = '/subscription-manage';
    static readonly Admin_Subscription_manage: string = '/subscription-manage/:id';
    //************************************************************************************************************ */
    static readonly Login_page: string = '/login';
    static readonly Login_OTP: string = '/otp';
    static readonly Login_Logout: string = '/logout';

    //Dashboard
    static readonly Dashborad_page: string = '/dashboard';

    static readonly User_profile: string = "/user-profile";
}